import { NgModule } from '@angular/core';
import { UsersTabsComponent } from './users-tabs.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    UsersTabsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    UsersTabsComponent
  ]
})
export class UsersTabsModule { }
